import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Radio } from 'antd';
import * as styles from './create-order.css';

const Question = ({ choices, value, onChange, intl }) =>
  <div className={styles.questionContainer}>
    <div className={styles.question}>
      {intl.formatMessage({ id: 'orderWizard.QUESTION' })}
    </div>
    <div>
      <Radio.Group value={value} onChange={e => onChange(e.target.value)}>
        {
          choices?.map(item => <Radio className={styles.choice} key={item.id} value={item.id}>
            {intl.formatMessage({ id: item.translationKey })}
          </Radio>)
        }
      </Radio.Group>
    </div>
  </div>;

Question.propTypes = {
  choices: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  value: PropTypes.string,
};

export default injectIntl(Question);
